import React, { useId } from 'react';
import { SearchIcon, XIcon } from '../icons';

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    inputClassName?: string;
    onFocus?: () => void;
    autoFocus?: boolean;
    id?: string;
    name?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
    value,
    onChange,
    placeholder = 'Pesquisar...',
    className = '',
    inputClassName = '',
    onFocus,
    autoFocus,
    id: idProp,
    name: nameProp,
}) => {
    const generatedId = useId();
    const inputId = idProp ?? generatedId;
    const inputName = nameProp ?? inputId;

    return (
        <div className={`input-group input-group--left-icon ${className}`.trim()}>
            <span className="input-icon">
                <SearchIcon className="h-4 w-4" />
            </span>
            <input
                id={inputId}
                name={inputName}
                type="search"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onFocus={onFocus}
                autoFocus={autoFocus}
                autoComplete="off"
                className={`input ${inputClassName} ${value ? 'input--right-icon' : ''}`.trim()}
                placeholder={placeholder}
                aria-label={placeholder}
            />
            {value && (
                <button
                    onClick={() => onChange('')}
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted transition-colors hover:text-default"
                    type="button"
                    aria-label="Limpar busca"
                    title="Limpar busca"
                >
                    <XIcon className="h-4 w-4" />
                </button>
            )}
        </div>
    );
};

export default SearchInput;
